<app-sidebar></app-sidebar>

<div class="p-4 sm:ml-64 bg-gray-100 h-screen">
   <div class="p-4 rounded-lg dark:border-gray-700">
      <div class="flex h-full w-full items-center justify-center mb-4 rounded">
      </div>
   </div>
</div>
